var map = {
	"./cow_cyrus.jpg": "721a",
	"./dabbing_ethan.jpg": "2275",
	"./ethan_artona.jpg": "26af",
	"./ethan_beedie.jpg": "3305",
	"./ethan_mae.png": "9bf4",
	"./ethan_moustache.png": "ad6f",
	"./ethan_orlando.png": "41a4",
	"./ethan_quarantine.png": "fd9f",
	"./infinite_ethan.gif": "014c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2358";